"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// These are prop types specific to UDS TextInput; see also ../utils/props/textInputProps
// for generic React Native props and HTML input attrs that are passed through.
const textInputPropTypes = {
  /**
   * If the input's state is to be controlled by a parent component, use this prop
   * together with the `onChange` to pass down and update the lifted state.
   */
  value: _propTypes.default.string,
  /**
   * Use this to set the type of the input. Defaults to `text`.
   */
  type: _propTypes.default.string,
  /**
   * Use this to set the initial value of an uncontrolled input.
   * Updating `initialValue` will **not** update the actual value.
   */
  initialValue: _propTypes.default.string,
  /**
   * Disables all user interactions with the input.
   */
  inactive: _propTypes.default.bool,
  /**
   * Makes it impossible to change the input's value.
   */
  readOnly: _propTypes.default.bool,
  /**
   * Use to react upon input's value changes. Required when the `value` prop is set.
   * Will receive the input's value as an argument.
   */
  onChange: _propTypes.default.func
};
var _default = exports.default = textInputPropTypes;